
import search from './search';
import table from './table';
import addEdit from './addEdit';
import simpleForm from './simpleForm';
import location from './location';
import toolbar from './toolbar';
import category from './pageCompo/category';
import addCategory from './pageCompo/addCategory';
import application from './pageCompo/application';
import addApplication from './pageCompo/addApplication';
import editAppFun from './pageCompo/editAppFun';
import dataVisual from './dataVisual';
import order from './pageCompo/order';

let component = {
  search,
  tabula: table,
  addEdit,
  simpleForm,
  location,
  toolbar,
  category,
  addCategory,
  application,
  addApplication,
  editAppFun,
  dataVis: dataVisual,
  order
};

const install = (Vue) => {
  Object.keys(component).forEach((key) => {
    Vue.component(`x-${key}`, component[key]);
  });
};

export default Object.assign({}, component, { install });



// WEBPACK FOOTER //
// ./src/package/index.js